import React, { useEffect, useState } from "react";
import "./shoppingcartloader.scss";
import { Default } from "react-spinners-css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { useSelector } from "react-redux";
import { selectors as headerSelector } from '../../../state/features/header';
import Alerts from "../../Alerts";
import * as signalR from "@microsoft/signalr";

const ShoppingCartLoader = () => {

    const { t } = useTranslation();
    const [step, setStep] = useState<number>(0);
    const [stepPercentage, setStepPercentage] = useState<number>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>("");
    const [notificationData, setNotificationData] = useState<any>(false);
    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state)
        })
    );

    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl('/signalr')
            .withAutomaticReconnect()
            .build();

        connection.start()
            .then(() => {
                connection.on(`shoppingcartrefresh-${headercurrentuser?.azureADId}`, (data: any) => {
                    updateNotification(data);
                });
                console.log('Connected to SignalR')
            })
            .catch(error => console.log('Connection failed: ', error));

        return () => {
            connection.stop();
        };
    }, []);

    const updateNotification = (data: any) => {
        const notificationData = JSON.parse(data);
        setNotificationData(notificationData);
        setStep(notificationData.step);
        if (notificationData.isError) {
            setShowAlert(true);
            setErrorMessage(notificationData?.message);
        }
    }

    useEffect(() => {
        setStepPercentage(step * 33.33);
    }, [step, notificationData])

    const getClass = (index: number) => {
        if (index == step) {
            return notificationData?.isError? "indexedStep error" : "indexedStep inprogress accomplished";
        }
        else if (index < step) {
            return "indexedStep accomplished";
        }
        else {
            return "indexedStep";
        }
    }

    const getDiv = (index: number) => {
        if (index == step) {
            return (notificationData?.isError ? (<div className="fa fa-remove"></div>) : <Default color="#fff" size={20} />);
        }
        else if (index < step) {
            return (<div className="fa fa-check"></div>);
        }
        else {
            return null;
        }
    }

    const handleErrorClose = () => {
        setShowAlert(false);
        setErrorMessage("");
    }

    return (
        <>
            {showAlert && (
                <Alerts
                    messageAlert={errorMessage}
                    alertType={'error'}
                    time={10000} onClose={handleErrorClose}
                />
            )}
            <ProgressBar percent={stepPercentage}>
                <Step>
                    {() => (
                        <>
                            <div className={getClass(0)}>
                                {getDiv(0)}
                            </div>
                            <div className="title">{t(RESOURCE.MyK_Label_SC_Refresh_Loader_Step1)}</div>
                        </>
                    )}
                </Step>
                <Step>
                    {() => (
                        <>
                            <div className={getClass(1)}>
                                {getDiv(1)}
                            </div>
                            <div className="title">{t(RESOURCE.MyK_Label_SC_Refresh_Loader_Step2)}</div>
                        </>
                    )}
                </Step>
                <Step>
                    {() => (
                        <>
                            <div className={getClass(2)}>
                                {getDiv(2)}
                            </div>
                            <div className="title">{t(RESOURCE.MyK_Label_SC_Refresh_Loader_Step3)}</div>
                        </>
                    )}
                </Step>
                <Step>
                    {() => (
                        <>
                            <div className={getClass(3)}>
                                {getDiv(3)}
                            </div>
                            <div className="title">{t(RESOURCE.MyK_Label_SC_Refresh_Loader_Step4)}</div>
                        </>
                    )}
                </Step>
            </ProgressBar>
        </>
    );
};

export default ShoppingCartLoader;
